document.querySelectorAll('input[type="file"]').forEach(e => {
    e.addEventListener('change', (event) => {
        const curFiles = e.files;
        const selectedClass = 'file-selected';
        if (curFiles.length > 0) {
            e.classList.add(selectedClass);
        } else {
            e.classList.remove(selectedClass);
        }
    })
});